import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ProjectsService} from '../_services/projects.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SingleProjectModel} from '../_models/singleProject.model';
import {FormBuilder} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-task-modal',
    templateUrl: './task-modal.component.html',
    styleUrls: ['./task-modal.component.scss']
})
export class TaskModalComponent implements OnInit, OnDestroy {
    @Input() closeRef;
    @Input() projectData: SingleProjectModel;


    // subscriptions
    unsubscribe = [];

    constructor(private projectsService: ProjectsService,
                private route: ActivatedRoute,
                private router: Router,
                private modalService: NgbModal,
                private fb: FormBuilder) {
    }

    ngOnInit(): void {

    }

    ngOnDestroy() {
        this.unsubscribe.forEach(el => el.unsubscribe());
    }

}
